import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const CurrencyPricesReducer = (state = { bitcoin: {}, steem: {}, steem_dollars: {} }, { type, payload }) => {
    switch (type) {
        case SteemActionType.LOAD_CURRENCY_PRICES:
            return payload;
        default:
            return state;
    }
};
export default CurrencyPricesReducer;
